import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';

import { Whitelist, WhitelistService } from '../whitelist/whitelist.service';
import { Workspace, WorkspaceService } from '../workspace/workspace.service';
import { WsLimit, WsLimitService } from '../wslimit/wslimit.service';
import { WsUsageService, WsUsageListParams, WsUsageList } from './wsusage.service';

import { Auth } from '../../auth.service';
import { Fmt } from '../../fmt.service';
import { WsUsageFIlter } from './wsusage.filter';

import { WsSettingDialogComponent } from '../wssettingDialog/wssettingDialog.component';

@Component({
    selector: 'wsusage',
    templateUrl: './wsusage.component.html',
    styleUrls: ['./../app/app.component.css'],
    providers: [
        Fmt,
        WsUsageService,
        WsUsageFIlter,
        WhitelistService,
    ],
})
export class WsUsageComponent implements OnInit {
    public definedColumns: string[];

    public tableFilter: any = '';
    public newWID: string = '';

    // Page Setting
    public readonly pageDefaultSize: number = 5; // Default
    public pageSize: number = this.pageDefaultSize; // number of counts per page
    public readonly pageMax: number = 5; // Maximum number of counts per page
    public pageIndex: number = 1;
    public loading: boolean = false;

    // Search Filter
    public searchKey: string = 'wID'; // default search key
    public searchKeys = [
        { label: 'w_idで検索', value: 'wID' },
        { label: 'ワークスペース名で検索', value: 'wsName' },
    ];
    public wID: string = '';
    public wsName: string = '';

    // Search Validation
    public readonly oidLength: number = 24;
    public readonly oidPattern: string = '^[0-9a-f]+$';

    // Search Result
    public searched: boolean = false;
    public workspaces: Workspace[] = [];
    public totalCount: number = 0;
    public errMsg: string = '';
    public wIDErrMsg: string = '';

    // Dialog Element
    @ViewChild('dialog')
    editDialog: WsSettingDialogComponent;

    constructor(
        private _wsusageService: WsUsageService,
        public _whiteListService: WhitelistService,
        public _fmt: Fmt,
        private fb: FormBuilder,
    ) {
        // this.searchWorkspace();
    }

    ngOnInit(): void {
        this.tableColumns = this.editDialog.tableColumns;
    }

    public tableColumns: TableColumn[] = [];
    searchWorkspace() {
        this.loading = true;

        // Delete unselected search key
        if (this.searchKey === 'wID') {
            this.wsName = '';
        } else if (this.searchKey === 'wsName') {
            this.wID = '';
        }

        // If not set, default value is set
        if (!this.pageSize) {
            this.pageSize = this.pageDefaultSize;
        }

        let params: WsUsageListParams = {
            w_id: this.wID,
            name: this.wsName,
            per_page: this.pageSize,
            page: this.pageIndex,
        };

        this._wsusageService.LoadWsUsagesList<any>(params).subscribe(
            result => {
                let response = result;
                this.workspaces = response.workspaces;
                this.definedColumns = response.columns;
                this.totalCount = response.totalWorkspaces;

                if (response.w_id_error) {
                    this.wIDErrMsg = response.w_id_error;
                } else {
                    this.wIDErrMsg = '';
                }
                this.errMsg = '';

                this.searched = true;
                this.loading = false;
                this._fmt.log(response);
            },
            error => {
                this.loading = false;
                this.errMsg = error.error.error; // error message from apicore
                this.workspaces = [];
                console.log(error);
            },
        );
    }

    private utilsBuildColSettings = (targetForm: string, cols: Array<string>, preloadVal?: any) => {
        var targetCol = {};
        for (const key of cols) {
            targetCol[key] = [preloadVal ? preloadVal[key] : null, [Validators.required]];
        }
        this[targetForm] = this.fb.group(targetCol);
    };

    OpenEditDialog(workspace: Workspace, column: TableColumn, key: string) {
        this.editDialog.ToEditColumn(workspace, column, column.key);
    }

    displayValue(column: string, ws: Workspace) {
        var str = '';
        switch (column) {
            case 'items':
            case 'users':
            case 'datastores':
                str = ws[column] + ' / ' + this.valueForColumn(ws, column);
                break;
            case 'storage':
                str = Math.round(ws[column] * 10) / 10 + ' / ' + this.valueForColumn(ws, column);
                break;
            case 'workspace_admin':
                let i = 0;
                if (!ws.admin_users || ws.admin_users.length === 0) break;
                ws.admin_users.forEach((user) => {
                    if (i != 0) {
                        str = str + ',';
                    }

                    // limit display emails for a temporary implements
                    if (i > 2) {
                        str = str + '...';
                    } else {
                        str = str + user.email;
                    }

                    i++;
                });

                break;
            default:
                str = ws[column];
        }

        return str;
    }

    valueForColumn(ws: Workspace, column: string): number {
        let limit: number = ws[column + '_limit'];
        if (!limit) return 0;

        return ws[column + '_limit'] == 0 ? 0 : limit;
    }

    successCreateWorkspace(wID: string) {
        this.newWID = wID;
    }
}

export interface TableColumn {
    name: string;
    key: string;
    editable: boolean;
    status?: boolean;
}
